'use client';
import React from 'react';
import ImageDisplay from '../ImageDisplay/ImageDisplay';
/**
 * 링크 프리뷰 컴포넌트
 * 
 * URL 정보를 미리보기 형태로 표시합니다.
 * type이 'project'일 경우 프로젝트에 특화된 스타일을 적용합니다.
 * type이 'youtube'일 경우 임베디드 플레이어로 표시합니다.
 */ var LinkPreview = function(param) {
    var url = param.url, title = param.title, description = param.description, image = param.image, siteName = param.siteName, type = param.type, className = param.className;
    if (!url) return null;
    // 유튜브 영상 ID 추출 함수
    var extractYouTubeVideoId = function(youtubeUrl) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = youtubeUrl.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };
    // 유튜브 타입인 경우 임베디드 플레이어 표시
    if (type === 'youtube') {
        var videoId = extractYouTubeVideoId(url);
        if (!videoId) {
            // 유효한 유튜브 ID를 추출할 수 없는 경우 일반 링크로 표시
            return /*#__PURE__*/ React.createElement("a", {
                href: url,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "block mt-3 border border-red-200 dark:border-red-900 rounded-xl overflow-hidden hover:bg-red-50 dark:hover:bg-red-900/20 transition ".concat(className || ''),
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }, image && /*#__PURE__*/ React.createElement("div", {
                className: "relative w-full h-40"
            }, /*#__PURE__*/ React.createElement(ImageDisplay, {
                src: image,
                alt: title || "유튜브 영상",
                className: "w-full h-full object-cover"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "absolute inset-0 flex items-center justify-center"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-red-600 rounded-full p-3"
            }, /*#__PURE__*/ React.createElement("svg", {
                className: "w-8 h-8 text-white",
                fill: "currentColor",
                viewBox: "0 0 24 24"
            }, /*#__PURE__*/ React.createElement("path", {
                d: "M8 5v14l11-7z"
            }))))), /*#__PURE__*/ React.createElement("div", {
                className: "p-3"
            }, siteName && /*#__PURE__*/ React.createElement("div", {
                className: "text-sm text-red-600 dark:text-red-400 font-medium"
            }, siteName || 'YouTube'), title && /*#__PURE__*/ React.createElement("div", {
                className: "font-bold text-base mt-1"
            }, title), description && /*#__PURE__*/ React.createElement("div", {
                className: "text-sm text-gray-700 dark:text-gray-300 mt-1 line-clamp-2"
            }, description), /*#__PURE__*/ React.createElement("div", {
                className: "text-sm text-gray-500 mt-1 truncate"
            }, url)));
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "block mt-3 border border-red-200 dark:border-red-900 rounded-xl overflow-hidden ".concat(className || '')
        }, /*#__PURE__*/ React.createElement("div", {
            className: "relative pb-[56.25%] h-0 overflow-hidden"
        }, /*#__PURE__*/ React.createElement("iframe", {
            className: "absolute top-0 left-0 w-full h-full",
            src: "https://www.youtube.com/embed/".concat(videoId),
            title: title || "YouTube video player",
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })), /*#__PURE__*/ React.createElement("div", {
            className: "p-3 bg-white dark:bg-gray-900"
        }, title && /*#__PURE__*/ React.createElement("div", {
            className: "font-bold text-base text-gray-900 dark:text-white"
        }, title), description && /*#__PURE__*/ React.createElement("div", {
            className: "text-sm text-gray-700 dark:text-gray-300 mt-1 line-clamp-2"
        }, description), /*#__PURE__*/ React.createElement("div", {
            className: "mt-2 flex items-center"
        }, /*#__PURE__*/ React.createElement("svg", {
            className: "w-4 h-4 text-red-500 mr-1.5",
            viewBox: "0 0 24 24",
            fill: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "text-xs font-medium text-red-500 dark:text-red-400"
        }, siteName || 'YouTube'))));
    }
    // 프로젝트 타입인 경우 다른 스타일 적용
    if (type === 'project') {
        return /*#__PURE__*/ React.createElement("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "block mt-3 border-2 border-blue-200 dark:border-blue-800 rounded-xl overflow-hidden hover:bg-blue-50 dark:hover:bg-blue-900/20 transition ".concat(className || ''),
            onClick: function(e) {
                return e.stopPropagation();
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-col md:flex-row"
        }, image && /*#__PURE__*/ React.createElement("div", {
            className: "relative w-full md:w-1/3 h-48 md:h-auto"
        }, /*#__PURE__*/ React.createElement(ImageDisplay, {
            src: image,
            alt: title || "프로젝트 링크",
            className: "w-full h-full object-cover"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "absolute top-0 left-0 bg-blue-500 text-white text-xs px-2 py-1 rounded-br"
        }, "프로젝트")), /*#__PURE__*/ React.createElement("div", {
            className: "p-4 flex-1 bg-gradient-to-r from-blue-50 to-white dark:from-gray-800 dark:to-gray-900"
        }, siteName && /*#__PURE__*/ React.createElement("div", {
            className: "text-sm text-blue-600 dark:text-blue-400 font-medium"
        }, siteName), title && /*#__PURE__*/ React.createElement("div", {
            className: "font-bold text-lg mt-1 text-gray-900 dark:text-white"
        }, title), description && /*#__PURE__*/ React.createElement("div", {
            className: "text-sm text-gray-700 dark:text-gray-300 mt-2 line-clamp-3"
        }, description), /*#__PURE__*/ React.createElement("div", {
            className: "mt-3 flex items-center"
        }, /*#__PURE__*/ React.createElement("svg", {
            className: "w-4 h-4 text-blue-500 mr-1",
            fill: "currentColor",
            viewBox: "0 0 20 20"
        }, /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            d: "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
            clipRule: "evenodd"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "text-xs text-blue-600 dark:text-blue-400 truncate"
        }, url)))));
    }
    // 기본 스타일 (기존 코드)
    return /*#__PURE__*/ React.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "block mt-3 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden hover:bg-gray-50 dark:hover:bg-gray-800 transition ".concat(className || ''),
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, image && /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full h-40"
    }, /*#__PURE__*/ React.createElement(ImageDisplay, {
        src: image,
        alt: title || "링크 미리보기",
        className: "w-full h-full object-cover"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "p-3"
    }, siteName && /*#__PURE__*/ React.createElement("div", {
        className: "text-sm text-gray-500"
    }, siteName), title && /*#__PURE__*/ React.createElement("div", {
        className: "font-bold text-base mt-1"
    }, title), description && /*#__PURE__*/ React.createElement("div", {
        className: "text-sm text-gray-700 dark:text-gray-300 mt-1 line-clamp-2"
    }, description), /*#__PURE__*/ React.createElement("div", {
        className: "text-sm text-gray-500 mt-1 truncate"
    }, url)));
};
export default LinkPreview;
